// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1gGsb","balanceDisclaimer":"posDashboard_balanceDisclaimer__19cK3"};